module.exports = __webpack_public_path__ + "assets/icon-conductor-rope.b61b026c.svg";